/**
 * Browser geolocation for Club web (Mac Safari/Chrome + iPhone).
 * Default getCurrentPosition without timeout often hangs on Apple — never success, never error.
 */

const WIFI_OPTIONS = {
  enableHighAccuracy: false,
  timeout: 8000,
  maximumAge: 120000,
};

const GPS_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 15000,
  maximumAge: 0,
};

export function isValidMapCoordinate(lat, lng) {
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return false;
  if (la === 0 && ln === 0) return false;
  if (la < -90 || la > 90 || ln < -180 || ln > 180) return false;
  return true;
}

function requestPosition(options) {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      reject,
      options,
    );
  });
}

export function geolocationErrorMessage(error) {
  const code = error?.code;
  if (code === 'insecure') {
    return 'Lokasi hanya bisa diambil di HTTPS. Buka Club lewat https, bukan http.';
  }
  if (code === 'unsupported') {
    return 'Browser ini tidak mendukung lokasi perangkat.';
  }
  if (code === 1) {
    return 'Izin lokasi ditolak. Aktifkan Location Services untuk Safari/Chrome, lalu izinkan lokasi untuk situs ini.';
  }
  if (code === 2) {
    return 'Perangkat tidak bisa menentukan posisi saat ini. Tandai pin di peta atau cari alamat.';
  }
  if (code === 3) {
    return 'Waktu menunggu lokasi habis. Di Mac/iPhone cek izin lokasi browser, atau tandai pin di peta.';
  }
  return error?.message || 'Tidak bisa mengambil lokasi saat ini.';
}

function wrapGeoError(error) {
  const err = new Error(geolocationErrorMessage(error));
  err.code = error?.code;
  return err;
}

export async function getDeviceCoordinates() {
  if (typeof window !== 'undefined' && window.isSecureContext === false) {
    throw wrapGeoError({ code: 'insecure' });
  }
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    throw wrapGeoError({ code: 'unsupported' });
  }

  try {
    return await requestPosition(WIFI_OPTIONS);
  } catch (first) {
    if (first?.code === 1) throw wrapGeoError(first);
    try {
      return await requestPosition(GPS_OPTIONS);
    } catch (second) {
      throw wrapGeoError(second);
    }
  }
}
